import { useDispatch, useSelector } from "react-redux";

import { setCbtValue } from "../data/actions/cbt";
import { AppState } from "../data/reducers";

export function useCbtSaveGuestCheckbox({ indexPassenger }) {
  const { guestsToCreateInDynamicForm } = useSelector((state: AppState) => ({
    guestsToCreateInDynamicForm: state.cbt.guestsToCreateInDynamicForm,
  }));

  const dispatch = useDispatch();

  const isChecked =
    guestsToCreateInDynamicForm &&
    guestsToCreateInDynamicForm.includes(indexPassenger);

  const handleCheck = () => {
    const newGuestsToCreateInDynamicForm = isChecked
      ? guestsToCreateInDynamicForm.filter((index) => index !== indexPassenger)
      : (guestsToCreateInDynamicForm || []).concat(indexPassenger);

    dispatch(
      setCbtValue("guestsToCreateInDynamicForm", newGuestsToCreateInDynamicForm)
    );
  };

  return { isChecked, handleCheck };
}
